/** @jsxImportSource @emotion/react */
import React, { createRef, useEffect, useState } from "react";
import "./NavigationBar.css";
import { css, useTheme } from "@emotion/react";
import {useOutsideAlerter} from "../../../hooks/useOutsideAlerter";
import { useLanguage } from "LanguageContext";

const getInitials = (name: string) => {
  return name
    .split(" ")
    .map((word) => word[0])
    .join("")
    .toUpperCase();
};

interface UserButtonProps {
  name: string;
  jobTitle: string;
  email: string;
  img?: string;
  className?: string;
  isAdmin?: boolean;
  is_llid_user?: boolean;
}

const profilePicture = css`
  width: 44px;
  height: 44px;
  border-radius: 100%;
  border: 2px solid #cacbcd;
  object-fit: cover;
`;

const userButton = css`
  cursor: pointer;
  ul {
    list-style: none;
    padding: 12px  0px;
    margin: 0;
    li {
      padding: 8px 12px;
      cursor: pointer;
      text-align: left;
      margin: 0;
      display: block;
      cursor: pointer;
      &:hover {
        background-color: var(--bg-tertiary);
      }
    }

  }
  .dropdown-items {
    display: none;
    background-color: white;
    width: fit-content;
    position: absolute;
    top: 5rem;
    right: 0rem;
    border-radius: 0.5rem;
    z-index: 10;
    transform: translateY(-10px);
    box-shadow: 0px 9px 28px 8px #0000000D, 0px 6px 16px 0px #00000014, 0px 3px 6px -4px #0000001F;
    min-width: 200px;
  }
  .menu-toggled {
    display: flex;
    flex-direction: column;
  }
  .menu-toggled > li > a {
    display: flex;
    padding: 0px 8px;
    width: 100%;
    text-decoration: none;
  }
`;

const userLink = css`
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  text-align: left;
  margin-left: 15px;
  gap: 8px;
  padding: 2px;
`;

const UserButton: React.FC<UserButtonProps> = ({
  name,
  jobTitle,
  email,
  img,
  isAdmin,
  is_llid_user,
}) => {
  const [isMenuOpened, setIsMenuOpened] = useState(false)
  const profileWraperRef = createRef<HTMLUListElement>();
  const [outsideSideMenu] = useOutsideAlerter(profileWraperRef);
  const { t } = useLanguage();
   const theme = useTheme();
  
  useEffect(() => {
    if (isMenuOpened) setIsMenuOpened(prev => false)
  }, [outsideSideMenu]);

  const profileName = css`
  font-family: ${theme.typography.body_semiBold.fontFamily};
  font-size: ${theme.typography.body_semiBold.fontSize};
  font-weight: ${theme.typography.body_semiBold.fontWeight};
  line-height: ${theme.typography.body_semiBold.lineHeight};
  color: ${theme.colors.textDark};
`;

const profileInitials = css`
  background-color: #000;
  color: #fff;
  border-radius: 100%;
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const profileJob = css`
  font-family: ${theme.typography.body.fontFamily};
  font-size: ${theme.typography.body.fontSize};
  font-weight: ${theme.typography.body.fontWeight};
  line-height: ${theme.typography.body.lineHeight};
  color: ${theme.colors.textMedium};
  max-width: 12em;
  text-overflow: ellipsis;
  overflow: hidden;
`;

  return (
    <div css={userButton}>
      <button
        css={userLink}
        onClick={() => setIsMenuOpened(prev => !prev)}
      >
        {img ? (
          <img src={img} alt={name} css={profilePicture} />
        ) : (
          <div css={profileInitials}>{getInitials(name)}</div>
        )}

        <div className="userDetailsWrapper">
          <div css={profileName}>{name}</div>
          <div css={profileJob}>{email}</div>
        </div>
      </button>
      <ul ref={profileWraperRef} className={`dropdown-items ${isMenuOpened && "menu-toggled"}`}>
        {
          isAdmin && (<li role="button"> <a href="/api/admin"> {t("header_adminTitle")} </a> </li>)
        }
        { !is_llid_user && <li role="button"> <a href="/changepassword">{t("change_password_title")}</a></li>}
        <li role="button"> <a href="/api/app/signout"> {t("header_logoutTitle")} </a> </li>
      </ul>
    </div>
  );
};

export default UserButton;
